/* raices-fx.js — pausa las animaciones ambientales (Ken Burns, flotación,
   pulso, brillo) cuando su sección sale de la pantalla. Ahorra batería y
   mantiene el scroll fluido en celulares de gama baja. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var sections = document.querySelectorAll('.rc-hero, .rc-trust, .rc-feat, .rc-cats, .rc-promo');
    if (!sections.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('rc-fx-off', !e.isIntersecting);
      });
    }, { rootMargin: '80px 0px' });
    sections.forEach(function (s) { io.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
